import styles from './OpportunityDetailsContent.sass'
import Icon, { IconName } from '../../../components/Icon'
import * as React from 'react'
import { observer } from 'mobx-react'

interface ContentProps {
  children: React.ReactNode
}

export const OpportunityDetailsContent = observer(function Content({
  children,
}: ContentProps) {
  return <div className={styles.content}>{children}</div>
})

interface ContentItemProps {
  title: string
  icon?: IconName
  children?: React.ReactNode
}

export function OpportunityDetailsContentItem({
  title,
  icon,
  children,
}: ContentItemProps) {
  return (
    <div className={styles.contentItem}>
      <p className={styles.contentItemTitle}>{title}</p>
      <div className={styles.contentItemValue}>
        {icon && (
          <span className={styles.contentItemIcon}>
            <Icon auto name={icon} />
          </span>
        )}
        <span className={styles.contentItemText}>{children}</span>
      </div>
    </div>
  )
}

interface NoInfoProps {
  children: React.ReactNode
}

export function NoInfo({ children }: NoInfoProps) {
  return <p className={styles.noInfo}>{children}</p>
}
